import { render } from "./AddThirdParty.vue?vue&type=template&id=ecb21980"
import script from "./AddThirdParty.vue?vue&type=script&lang=js"
export * from "./AddThirdParty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__